export const storageName = 'adwise-vat-display';

const getVatDisplayFromSearchParam = () => {
  return new URLSearchParams(window.location.search).get('vat-display');
};

export const includingVat = () => {
  return window.localStorage.getItem(storageName) === 'including';
};

export default function vatToggle(store) {
  const vatDisplaySearchParam = getVatDisplayFromSearchParam();

  const update = (value) => {
    store.commit('data/setIncludingVat', value);
  };

  if (vatDisplaySearchParam !== null) {
    update(vatDisplaySearchParam === 'including');
  } else {
    update(includingVat());
  }

  const selector = '#tax-toggle-button';

  const inputElement = document.querySelector(selector);

  if (!inputElement) {
    console.error(`VAT toggle element not found with selector: '${selector}'`);
    return;
  }

  inputElement.addEventListener('click', () => {
    // Timeout is needed because the value is not in localStorage yet
    setTimeout(() => {
      update(includingVat());
    }, 50);
  });
}
